<div class="iss-drawer-header" *ngIf="withHeader">
  <ng-content select="iss-drawer-header"/>
</div>
<tui-scrollbar class="iss-drawer__scrollbar">
  <div class="iss-drawer-body">
    <ng-content select="iss-drawer-content"/>
  </div>
</tui-scrollbar>
<div class="iss-drawer-footer" *ngIf="withFooter">
  <ng-content select="iss-drawer-footer"/>
</div>
